export enum ContractActionItem {
  Add = 'add',
  Deleted = 'deleted',
  Updated = 'updated',
}
